<template>
  <ApexChart
    ref="chart"
    :options="options"
    :series="series"
    :height="height"
    :width="width"
  />
</template>

<script>
import ApexChart from 'vue-apexcharts'

export default {
  components: { ApexChart },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: 350,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
